import { useEffect, useState } from "react";
import api from "@/lib/api";
import SectionHeader from "@/components/layout/SectionHeader";

export default function TopAirlines() {
  const [airlines, setAirlines] = useState([]);
  useEffect(() => { api.get("/airlines").then(({ data }) => setAirlines(data)).catch(() => {}); }, []);
  if (!airlines.length) return null;

  const loop = [...airlines, ...airlines]; // duplicated for seamless marquee

  return (
    <section data-testid="top-airlines" className="py-16 md:py-20">
      <div className="container-page">
        <SectionHeader
          align="center"
          kicker="Top Airlines"
          title="Fly with the best in the sky"
          subtitle="We compare fares across 600+ airlines — including these flagship carriers Indian travellers know and trust."
        />
      </div>
      <div className="relative overflow-hidden">
        <div className="marquee-track gap-12 md:gap-16 px-6">
          {loop.map((a, i) => (
            <div
              key={`${a.code}-${i}`}
              className="shrink-0 w-40 h-20 inline-flex items-center justify-center bg-white"
              data-testid={`airline-${a.code.toLowerCase()}`}
            >
              <img
                src={a.logo}
                alt={a.name}
                title={a.name}
                className="max-h-12 max-w-[140px] object-contain grayscale hover:grayscale-0 opacity-70 hover:opacity-100 transition-all duration-300"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
